import { ref, computed } from 'vue';
import { $get, $post } from './useApi';
import { useStorage } from '@vueuse/core';

const apiKey = useStorage(import.meta.env.VITE_LOCALSTORAGE_KEY_NAME + '_api_key', null);

const sessionInfo = ref({});

const isLoggedInUser = computed(() => Boolean(apiKey.value));

async function getWhoAmI() {
  const response = await $get('/auth/', null, {
    onError: () => {} // do nothing
  });

  if (response?.error) {
    apiKey.value = null;
    sessionInfo.value = {};
    return;
  }

  sessionInfo.value = response.session_info;
  if (import.meta.env.DEV) {
    console.log('SESSION_INFO', response.session_info);
  }
}

async function login(username, password) {
  const response = await $post('/auth/', { username, password });

  const session = response?.session_info || null;

  if (!session) {
    apiKey.value = null;
    sessionInfo.value = {};
    return;
  }

  apiKey.value = session.api_key;
  delete session.api_key;
  sessionInfo.value = session;
}

function logout() {
  apiKey.value = null;
  sessionInfo.value = {};
}

export {
  apiKey,
  sessionInfo,
  isLoggedInUser,
  getWhoAmI,
  login,
  logout
};
